import { computed } from 'vue'
import * as Sentry from '@sentry/vue'

import { useSessionStore } from 'app_alegra_commons/session'
import { loadRoutes } from 'app_alegra_commons/lazyLoadModule'
import { lazyLoadModule } from 'app_alegra_commons/lazyLoadModule'
import { useAppStore } from 'app_alegra_commons/app'
import { getDictonaryFromObject } from 'app_alegra_commons/utils'
import { convertDictionaryToObject, jwtDecode } from '../utils/appHelpers'
import { useMembershipStore } from 'app_alegra_commons/membership'
import packageJson from '../../../package.json'

export default function () {
  const SESSION = useSessionStore()
  const APP = useAppStore()
  const MEMBERSHIP = useMembershipStore()

  const loading = computed(() => APP.globalLoading)

  const loadUserInfo = async (dictionary: object): Promise<void> => {
    await SESSION.getUser(dictionary)
    addToDictionary(convertDictionaryToObject())
  }

  const reloadUserInfo = async (): Promise<void> => {
    await SESSION.reloadUserInfo()
  }

  const addToDictionary = (dictionary: object) => {
    const d = getDictonaryFromObject(dictionary, APP.userLenguage, APP.appVersion)
    APP.addToDictionary(d)
  }

  const sentryInit = () => {
    const jwt = jwtDecode()

    const userContext = {
      id: jwt?.idu,
      email: jwt?.email,
    }

    const companyContext = {
      id: jwt?.idc,
      version: jwt?.applicationVersion,
    }

    Sentry.setUser(userContext)
    Sentry.setContext('company', companyContext)
  }

  const generateVersionCache = () => {
    const { version } = packageJson
    const date_ob = new Date()
    let moduleVersion: string | number = Date.now()

    if (process.env.VUE_APP_ENVIROMENT == 'production') {
      moduleVersion =
        ('0' + (date_ob.getMonth() + 1)).slice(-2) +
        ('0' + date_ob.getDate()).slice(-2) +
        date_ob.getHours()
    }

    return `${moduleVersion}${version}`
  }

  const loadMicrofront = async ({ domain, moduleName, nameExportedRoutes }) => {
    try {
      const version = generateVersionCache()

      const { microSettings, childrens } = await loadRoutes({
        domain,
        moduleName,
        nameExportedRoutes,
        cache: version,
      })

      addToDictionary(microSettings.dictionary)

      return childrens
    } catch (error) {
      console.log(error)
    }
  }

  const loadMicrofrontVue2 = async ({ domain, moduleName }) => {
    try {
      const version = generateVersionCache()

      const { mountApp } = await lazyLoadModule(
        `${domain}/remoteEntry.js?v=${version}`,
        moduleName,
        './microfront'
      )

      return mountApp
    } catch (error) {
      console.log(error)
    }
  }

  const getHasOnlyInvoiceCustomUi = async () => {
    const versionWithCustomUi = ['costaRica']
    if (versionWithCustomUi.includes(SESSION.company.applicationVersion)) {
      return await MEMBERSHIP.hasOnlyInvoiceCustomUi()
    }
    return false
  }

  return {
    addToDictionary,
    loadUserInfo,
    reloadUserInfo,
    loadMicrofront,
    loadMicrofrontVue2,
    loading,
    sentryInit,
    getHasOnlyInvoiceCustomUi,
  }
}
